
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import AddNewDialog from './AddNewDialog';

interface SelectionControlsProps {
  stateName: string;
  onStateNameChange: (value: string) => void;
  selectedCountry: string;
  onCountryChange: (value: string) => void;
  selectedLeague: string;
  onLeagueChange: (value: string) => void;
  selectedYear: string;
  onYearChange: (value: string) => void;
  countries: any[];
  leagues: any[];
  years: any[];
  newCountry: string;
  onNewCountryChange: (value: string) => void;
  onAddCountry: () => void;
  newLeague: string;
  onNewLeagueChange: (value: string) => void;
  onAddLeague: () => void;
  newYear: string;
  onNewYearChange: (value: string) => void;
  onAddYear: () => void;
}

const SelectionControls: React.FC<SelectionControlsProps> = ({
  stateName,
  onStateNameChange,
  selectedCountry,
  onCountryChange,
  selectedLeague,
  onLeagueChange,
  selectedYear,
  onYearChange,
  countries,
  leagues,
  years,
  newCountry,
  onNewCountryChange,
  onAddCountry,
  newLeague,
  onNewLeagueChange,
  onAddLeague,
  newYear,
  onNewYearChange,
  onAddYear,
}) => {
  // Filter leagues based on selected country
  const filteredLeagues = React.useMemo(() => {
    if (!selectedCountry) return [];
    return leagues.filter(league => league.country === selectedCountry);
  }, [leagues, selectedCountry]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1fr_auto] gap-4 items-start">
      <Input 
        type="text" 
        placeholder="State Name" 
        value={stateName}
        onChange={(e) => onStateNameChange(e.target.value)}
        className="w-full"
      />
      
      <div className="flex gap-2">
        <Select value={selectedCountry} onValueChange={onCountryChange}>
          <SelectTrigger>
            <SelectValue placeholder="Select Country" />
          </SelectTrigger>
          <SelectContent>
            {countries.map((country) => (
              <SelectItem key={country.id} value={country.name}>
                {country.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        
        <AddNewDialog
          title="Country"
          value={newCountry}
          onChange={onNewCountryChange}
          onAdd={onAddCountry}
        />
      </div>

      <div className="flex gap-2">
        <Select 
          value={selectedLeague} 
          onValueChange={onLeagueChange}
          disabled={!selectedCountry}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select League" />
          </SelectTrigger>
          <SelectContent>
            {filteredLeagues.map((league) => (
              <SelectItem key={league.id} value={league.name}>
                {league.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <AddNewDialog
          title="League"
          value={newLeague}
          onChange={onNewLeagueChange}
          onAdd={onAddLeague}
          disabled={!selectedCountry}
        />
      </div>

      <div className="flex gap-2">
        <Select 
          value={selectedYear} 
          onValueChange={onYearChange}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select Year" />
          </SelectTrigger>
          <SelectContent>
            {years.map((year) => (
              <SelectItem key={year.id} value={year.year}>
                {year.year}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <AddNewDialog
          title="Year"
          value={newYear}
          onChange={onNewYearChange}
          onAdd={onAddYear}
        />
      </div>
    </div>
  );
};

export default SelectionControls;
